import { ReactComponent as IconHeader } from '@/assets/svgs/arrow-right-on-rectangle.svg'
import { ReactComponent as IconSelectedCreateFolder } from "@/assets/svgs/folder-with-add-solid.svg"
import { ReactComponent as IconCreateFolder } from "@/assets/svgs/folder-with-add.svg"
import { ReactComponent as IconSelectedFolder } from "@/assets/svgs/folder-with-tick-solid.svg"
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import { ReactComponent as IconFolder } from "@/assets/svgs/package-folder-icon.svg"
import { ReactComponent as IconPin } from "@/assets/svgs/pin-to-top-active.svg"
import Button from '@/components/Button/index'
import InputSuffixIcon from '@/components/InputSuffixIcon'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from '@/context/toast/index'
import usePackageFolders from '@/hooks/use-package-folder/index'
import { useParams } from '@/lib/router-dom/index'
import packageFolderApi from "@/services/api/packageFolder.js"
import rem from '@/utils/rem'
import classname from 'classnames'
import { useContext, useEffect, useState } from 'react'
import MultiClamp from 'react-multi-clamp'

function MovePackageToFolderModal({ isVisible, hideModal, packageId }) {

	/*=================================================/
		General
	/================================================*/
	const { addToastMessage } = useContext(ToastContext);
	// const params = useParams();
	const { folderId } = useParams();

	const [selectedFolder, setSelectedFolder] = useState("")
	const [searchFolder, setSearchFolder] = useState("")
	const [createFolder, setCreateFolder] = useState(false)
	const [folderName, setFolderName] = useState("")
	const [errorMessage, setErrorMessage] = useState("")


	const folderWrapperClass = classname({
		'move-package-model__folders-wrapper': !createFolder,
		'inactive-wrapper': createFolder
	})

	const folderNameClass = classname({
		'move-package-model__folder-name': true,
		'folder-inactive': createFolder
	})

	const folderIconClass = classname({
		'move-package-model__folder-icon': true,
		'folder-inactive': createFolder
	})

	const folderPinClass = classname({
		'move-package-model__folder-pin': true,
		'folder-inactive': createFolder
	})

	const createFolderIconClass = classname({
		'move-package-model__folder-icon': true,
		'selected-folder__icon': createFolder
	})

	/*=================================================/
		Hooks
	/================================================*/

	const { folders, fetchAllFolders } = usePackageFolders()

	useEffect(() => {
		if (isVisible) {
			fetchAllFolders()
		}
	}, [isVisible])

	/*=================================================/
		Fuctions
	/================================================*/

	const foldersList = folders.filter(folder => folder.isVeridapt !== true && folder.id !== folderId)

	async function movePackageToFolder(folderId) {
		const [error] = await packageFolderApi.movePackage(packageId, { folderId });

		if (error) {
			return addToastMessage('Failed to move the package', 'error')
		}

		addToastMessage('You have successfully move the Package to the selected folder.', 'success')
		document.getElementById('reload-eclips')?.click()
		closeModal()
	}

	async function createNewFolder() {
		const [error, result] = await packageFolderApi.createFolder({ name: folderName });

		if (error) {
			return addToastMessage('Failed to create a folder', 'error')
		}

		movePackageToFolder(result.id)
	}

	function closeModal() {
		hideModal()
		setSelectedFolder("")
		setCreateFolder(false)
		setFolderName("")
		setSearchFolder("")
		setErrorMessage("")
	}

	const validateFolderName = (name) => {
		let regex = /^[\w\-\s]+$/
		setErrorMessage(
			regex.test(name)
				? ''
				: 'Please re-enter the text. Input field allow only Alphanumeric, Hyphen or Space as characters.',
		)
	}

	return (
		<Modal visible={isVisible} variant='medium'  close={closeModal}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon--package'}>
										<IconHeader />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Move
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="move-package-modal__search-input">
							<InputSuffixIcon
								maxWidth={450}
								placeholder="Search Folders"
								icon={<IconSearch />}
								value={searchFolder}
								onChange={(e) => {
									setSearchFolder(e?.target.value)
									setCreateFolder(false)
									setFolderName("")
									setSelectedFolder("")
									setErrorMessage("")
								}}
							/>
						</div>
						<div className="move-package-modal__wrapper">
							<div className="move-package-modal__folder-selection-list">
								<div className="move-package-model__create-folders-wrapper" >
									<div className="move-package-model__create-folders-content">
										<div className={createFolderIconClass}>
											{createFolder ? <IconSelectedCreateFolder /> : <IconCreateFolder />}
										</div>
										<div className="move-package-model__create-folder-input" >
											<input
												type="text"
												placeholder='Create New Folder'
												value={folderName}
												onChange={(e) => {
													setFolderName(e?.target.value)
													validateFolderName(e?.target.value)
												}}
												onClick={() => {
													setCreateFolder(true)
													setSelectedFolder("")
												}}
											/>
										</div>
									</div>
									{errorMessage && folderName !== '' && (
										<div className="folder-name-err-msg">{errorMessage}</div>
									)}
								</div>
								{foldersList.filter((folderItem) => {
									return searchFolder.toLowerCase() === ""
										? folderItem
										: folderItem.name.toLowerCase().includes(searchFolder.toLowerCase())
								}).map((item) => {
									return (
										<>
											<div
												className={folderWrapperClass + (selectedFolder === item.id ? ' selected-folder' : '')}
												onClick={() => {
													setSelectedFolder(item.id)
													setCreateFolder(false)
													setFolderName("")
													setErrorMessage("")
												}}
												key={item.id}
											>
												<div className={folderIconClass + (selectedFolder === item.id ? ' selected-folder__icon' : '')}>
													{selectedFolder === item.id ? <IconSelectedFolder /> : <IconFolder />}
												</div>
												<div className={folderNameClass}><MultiClamp clamp={2}>{item.name || 'Untitled Folder'}</MultiClamp></div>
												<div className={folderPinClass}>{item.pinned ? <IconPin /> : <div></div>}</div>
											</div>
										</>
									)
								})}
							</div>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={closeModal} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Next"
							submit={() => {
								if (selectedFolder && !folderName) {
									movePackageToFolder(selectedFolder)
								}
								if (folderName && !selectedFolder) {
									createNewFolder()
								}
							}}
							disabled={!(selectedFolder || (folderName && !errorMessage))}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}

export default MovePackageToFolderModal
